<template>

    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :label-width="90" label-position="right">
                                <FormItem :label="t.exchange.createTime" prop="createTime">
                                    <Input v-model.trim="formItem.createTime" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.exchange.jpy" prop="jpy">
                                    <Input v-model.trim="formItem.jpy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.exchange.usd" prop="jpy">
                                    <Input v-model.trim="formItem.usd" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.exchange.hkd" prop="jpy">
                                    <Input v-model.trim="formItem.hkd" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.exchange.eur" prop="jpy">
                                    <Input v-model.trim="formItem.eur" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.exchange.gpb" prop="jpy">
                                    <Input v-model.trim="formItem.gpb" readonly></Input>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import { getExchangeInfo } from '@/api/exchange';

export default {
    name: 'content_exchange_detail',
    data() {
        const t = this.$_t();
        return {
            self: this,
            t: t,
            formItem: {
                jpy: '',
                usd: '',
                hkd: '',
                eur: '',
                gpb: '',
                year: '',
                month: '',
                day: '',
            },
        };
    },
    methods: {
        async init() {
            const exchangeInfo = await getExchangeInfo(this.$route.params.id);
            if (exchangeInfo.exchange != null) {
                this.formItem = exchangeInfo.exchange;
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
</style>
